import { render, staticRenderFns } from "./que.vue?vue&type=template&id=2c7afe56&scoped=true&"
import script from "./que.vue?vue&type=script&lang=js&"
export * from "./que.vue?vue&type=script&lang=js&"
import style0 from "./que.vue?vue&type=style&index=0&id=2c7afe56&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7afe56",
  null
  
)

export default component.exports